import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { Button } from 'redpoints-front-components/index';

import {
  allIncidentsExportBrandData,
  allIncidentsExportEnforcementData,
  allIncidentsExportPiracyData,
} from '../../../actions/allIncidentsActions';
import {
  getAllIncidentsFilters,
  getAllIncidentsFiltersLevelStatusData,
  getAllIncidentsTableData,
  getAllIncidentsTableExportIsLoading,
  getAllIncidentsTableHasExportBrandPermission,
  getAllIncidentsTableHasExportPiracyPermission,
} from '../../../reducers/reporting/allIncidents';
import { REPORT_TYPE } from './AllIncidents';
import { translate } from '../../../helpers/languageHelper';

const AllIncidentsTableActions = ({
  allIncidentsExportBrandData,
  allIncidentsExportEnforcementData,
  allIncidentsExportPiracyData,
  filtersValues,
  hasExportBrandPermission,
  hasExportPiracyPermission,
  incidentLevelStatusData,
  incidentsData,
  isLoading,
  reportType,
}) => {
  const handleExportBrandDataToCSV = useCallback(() => {
    allIncidentsExportBrandData({
      filters: filtersValues,
      incidentLevelStatusData,
    });
  }, [allIncidentsExportBrandData, filtersValues, incidentLevelStatusData]);

  const handleExportPiracyDataToCSV = useCallback(() => {
    allIncidentsExportPiracyData({
      filters: filtersValues,
      incidentLevelStatusData,
    });
  }, [allIncidentsExportPiracyData, filtersValues, incidentLevelStatusData]);

  const handleEnforcementDataToCSV = useCallback(() => {
    allIncidentsExportEnforcementData({
      filters: filtersValues,
      incidentLevelStatusData,
    });
  }, [
    allIncidentsExportEnforcementData,
    filtersValues,
    incidentLevelStatusData,
  ]);

  const content = get(incidentsData, 'content', []) || [];
  const disableButtons = content.length <= 0 || isLoading;

  const showEnforcementDataBtn = reportType === REPORT_TYPE.INTERNAL;
  return (
    <>
      {hasExportBrandPermission && (
        <Button
          aria-label="exportBrandBtn"
          className="ant-btn-md"
          type="primary"
          onClick={handleExportBrandDataToCSV}
          disabled={disableButtons}
        >
          {translate('allIncidents.exportBrandDataToCSV.btnText')}
        </Button>
      )}
      {hasExportPiracyPermission && (
        <Button
          aria-label="exportPiracyBtn"
          className="ant-btn-md"
          type="primary"
          onClick={handleExportPiracyDataToCSV}
          disabled={disableButtons}
        >
          {translate('allIncidents.exportPiracyDataToCSV.btnText')}
        </Button>
      )}
      {showEnforcementDataBtn && (
        <Button
          aria-label="enforcementDataBtn"
          className="ant-btn-md"
          type="primary"
          onClick={handleEnforcementDataToCSV}
          disabled={disableButtons}
        >
          {translate('allIncidents.enforcementDataToCSV.btnText')}
        </Button>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  isLoading: getAllIncidentsTableExportIsLoading(state),
  filtersValues: getAllIncidentsFilters(state),
  incidentLevelStatusData: getAllIncidentsFiltersLevelStatusData(state),
  incidentsData: getAllIncidentsTableData(state),
  hasExportBrandPermission: getAllIncidentsTableHasExportBrandPermission(state),
  hasExportPiracyPermission: getAllIncidentsTableHasExportPiracyPermission(
    state
  ),
});

export default connect(mapStateToProps, {
  allIncidentsExportBrandData,
  allIncidentsExportEnforcementData,
  allIncidentsExportPiracyData,
})(AllIncidentsTableActions);
